<div class="download-extension-container row">
    <div class="col-lg-6 margin-top-15px">
        <a [href]="chromeStoreUrl | safeUrl" target="_blank">
            <img
                [attr.width]="imageWidth"
                src="@imagesDir/ChromeWebStore.png"
                alt="---ChromeWebStore.png---"
                title="" />
        </a>
    </div>
    <div class="col-lg-6 margin-top-15px">
        <a [href]="firefoxStoreUrl | safeUrl" target="_blank">
            <img
                [attr.width]="imageWidth"
                src="@imagesDir/FirefoxWebStore.png"
                alt="---FirefoxWebStore.png---"
                title="" />
        </a>
    </div>
</div>
